export default {
  data() {
    return {
      filter: {
        platformName: "",
        platformKey: "",
      },
      searchPlatformData: [],
      searchPlatformTimer: [],
    };
  },
  watch: {
    "filter.platformName"(val) {
      if (!val) this.filter.platformKey = "";
    },
  },
  methods: {
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      if (this.searchPlatformTimer) {
        clearTimeout(this.searchPlatformTimer);
      }
      this.searchPlatformTimer = setTimeout(() => {
        this.filter.platformKey = "";
        let postData = {
          platformName,
          pageNow: 1,
          pageSize: 9999,
        };
        this.$service.post("getPlatformList", postData).then(result => {
          if (result.$.checkResult(result, true)) {
            let rows = result.data.rows.splice(0);
            this.searchPlatformData = rows;
            cb(rows);
          }
        });
      }, 100);
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
      this.filter.platformKey = item.platformKey;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
    },
  },
};
